const state = {
  audio: null,
  currentAudio: null,
  video: null,
  videoElement: null
}

const mutations = {
  UPDATE_AUDIO (pState, payload) {
    pState.audio = payload
  },
  UPDATE_CURRENT_AUDIO (pState, payload) {
    pState.currentAudio = payload
  },
  UPDATE_VIDEO (pState, payload) {
    pState.video = payload
  },
  UPDATE_VIDEO_ELEMENT (pState, payload) {
    pState.videoElement = payload
  }
}

const getters = {
  GET_AUDIO: state => state.audio,
  GET_CURRENT_AUDIO: state => state.currentAudio,
  GET_VIDEO: state => state.video,
  GET_VIDEO_ELEMENT: state => state.videoElement,
}

const actions = {
  setAudio ({ commit }, el) {
    commit('UPDATE_AUDIO', el)
  },
  setCurrentAudio ({ commit }, id) {
    commit('UPDATE_CURRENT_AUDIO', id)
  },
  setVideo ({ commit }, id) {
    commit('UPDATE_VIDEO', id)
  },
  setVideoElement ({ commit }, el) {
    commit('UPDATE_VIDEO_ELEMENT', el)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
